import React from 'react'
import { Badge, Tooltip } from 'antd'
import PropTypes from 'prop-types'

import { THEME } from '../../../../core/constants'

import {
  SCRAPING_RESPONSE_STATUS_IN_PROGRESS,
  SCRAPING_RESPONSE_STATUS_SUCCESS,
  SCRAPING_RESPONSE_STATUS_PARTIALLY_SUCCESSFULL,
  SCRAPING_RESPONSE_STATUS_ERROR,
  SCRAPING_RESPONSE_STATUSES,
  SCRAPING_RESPONSE_ERROR_CODES,
} from '../../../constants'

const backgroundColorByStatus = {
  [SCRAPING_RESPONSE_STATUS_IN_PROGRESS]: THEME.colors.yellow,
  [SCRAPING_RESPONSE_STATUS_SUCCESS]: THEME.colors.green,
  [SCRAPING_RESPONSE_STATUS_PARTIALLY_SUCCESSFULL]: THEME.colors.orange,
  [SCRAPING_RESPONSE_STATUS_ERROR]: THEME.colors.red,
}

const ScrapingResponseStatus = ({ status, code }) =>
  code ? (
    <Tooltip
      placement="top"
      title={SCRAPING_RESPONSE_ERROR_CODES[code]?.name || code}
    >
      <Badge
        count={SCRAPING_RESPONSE_STATUSES[status].name}
        style={{
          backgroundColor: backgroundColorByStatus[status],
        }}
      />
    </Tooltip>
  ) : (
    <Badge
      count={SCRAPING_RESPONSE_STATUSES[status].name}
      style={{
        backgroundColor: backgroundColorByStatus[status],
      }}
    />
  )

ScrapingResponseStatus.propTypes = {
  status: PropTypes.string.isRequired,
  code: PropTypes.string,
}

ScrapingResponseStatus.defaultProps = {
  code: undefined,
}

export default ScrapingResponseStatus
